import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerConfigRelaysPageRoutingModule } from './manager-config-relays-routing.module';

import { ManagerConfigRelaysPage } from './manager-config-relays.page';
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedDirectivesModule,
    SharedComponentsModule,
    TranslateModule,
    ManagerConfigRelaysPageRoutingModule
  ],
  declarations: [ManagerConfigRelaysPage]
})
export class ManagerConfigRelaysPageModule {}
